import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ▼▼▼ ADDED ▼▼▼
import { useLocation } from 'react-router-dom'; // ▼▼▼ ADDED ▼▼▼
import './Garden.css'; // クラフトページでも流用可

const Craft = () => {
    const [lightboxImage, setLightboxImage] = useState(null);
    const { pathname } = useLocation(); // ▼▼▼ ADDED ▼▼▼

    // ▼▼▼ ADDED ▼▼▼
    // Function to open the lightbox
    const openLightbox = (imageSrc) => {
        setLightboxImage(imageSrc);
    };

    return (
        // ▼▼▼ Wrapped with Fragment <> ▼▼▼
        <>
            {/* ▼▼▼ ADDED THIS ENTIRE HELMET BLOCK ▼▼▼ */}
            <Helmet>
                <title>伝統工芸が佇む空間｜5つの魅力｜金沢之旅宿 あけぼの</title>
                <meta name="description" content="金沢之旅宿あけぼのでは、輪島塗や九谷焼、珠洲焼など石川・能登の伝統工芸品を館内に展示。美術館のように美しい工芸品に囲まれた、特別なご滞在をお楽しみください。" />
                <link rel="canonical" href={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:title" content="伝統工芸が佇む空間｜金沢之旅宿 あけぼの" />
                <meta property="og:description" content="輪島塗や九谷焼など石川・能登の伝統工芸品を館内に展示。美術館のように美しい工芸品に囲まれた、特別なご滞在をお楽しみください。" />
                <meta property="og:url" content={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:image" content="https://kanazawa-stay-akebono.com/images/machiya2.jpg" />
            </Helmet>
            {/* ▲▲▲ ADDITION ENDS HERE ▲▲▲ */}

            <div className="akebono-garden-page">

                {/* HEROセクション */}
                <section className="akebono-garden-hero" style={{ backgroundImage: "url('/images/machiya2.jpg')" }}>
                    <div className="akebono-garden-hero-overlay">
                        <h1>伝統工芸が佇む空間</h1>
                    </div>
                </section>

                {/* セクション①：石川・能登の伝統工芸品とは */}
                <section className="akebono-garden-culture">
                    <h2>石川・能登の伝統工芸品</h2>
                    <p>石川県には、古くから育まれてきた多彩な伝統工芸があります。なかでも、輪島塗・九谷焼・珠洲焼といった漆器・陶磁器文化は、加賀百万石の美意識と職人技術が融合した逸品として知られています。</p>
                    <p>また、能登半島では、ろうそくや和紙、酒器など、地域の暮らしと深く結びついた温もりある工芸品が今も作り続けられています。それらは単なる装飾ではなく、使う人の心を癒し、丁寧な日々の営みを支える道具でもあります。</p>
                    <p>あけぼのでは、そうした工芸品の魅力に直接触れ、泊まることで感じる特別な体験をご提供しています。</p>

                    <div className="akebono-garden-gallery">
                        {/* ▼▼▼ ADDED onClick HANDLERS ▼▼▼ */}
                        <img src="/images/craft-ishikawa1.jpg" alt="輪島塗" onClick={() => openLightbox('/images/craft-ishikawa1.jpg')} />
                        <img src="/images/craft-ishikawa2.jpg" alt="九谷焼" onClick={() => openLightbox('/images/craft-ishikawa2.jpg')} />
                        <img src="/images/craft-ishikawa3.jpg" alt="珠洲焼" onClick={() => openLightbox('/images/craft-ishikawa3.jpg')} />
                        <img src="/images/craft-ishikawa4.jpg" alt="高澤ろうそく" onClick={() => openLightbox('/images/craft-ishikawa4.jpg')} />
                    </div>
                </section>

                {/* セクション②：館内に展示されている工芸品の紹介 */}
                <section className="akebono-garden-feature">
                    <h2>館内を彩る工芸品</h2>
                    <p>館内には石川・能登を代表する伝統工芸品が各所に配されており、宿泊体験そのものが美術館巡りのようなひとときとなります。</p>

                    <div className="garden-card">
                        <img src="/images/crafts1.jpg" alt="輪島塗の器" onClick={() => openLightbox('/images/crafts1.jpg')} />
                        <div>
                            <h3>輪島塗</h3>
                            <p>石川県輪島市で作られる輪島塗は、堅牢さと美しさを兼ね備えた漆器として全国に名高い伝統工芸です。木地に漆を何十回も塗り重ねることで強度を増し、さらに「沈金」や「蒔絵」などの繊細な加飾が施され、芸術性も高く評価されています。</p>
                            <p>あけぼので展示している輪島塗は、現代の暮らしにも溶け込むよう、シンプルで洗練された意匠が特徴。1階和室に設えられた空間に自然と調和し、日常の中にさりげない豊かさをもたらしてくれます。</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/crafts2.jpg" alt="九谷焼の器" onClick={() => openLightbox('/images/crafts2.jpg')} />
                        <div>
                            <h3>九谷焼</h3>
                            <p>九谷焼は、加賀藩の美意識を受け継ぐ絢爛な陶磁器。赤・青・黄・紫・紺青の「九谷五彩」を基調とした大胆な色使いと、緻密で独創的な絵柄が世界でも高く評価されています。</p>
                            <p>あけぼのでは、九谷焼の湯呑や皿をリビングや寝室に展示しており、実際にお茶の時間にもご使用いただけます。華やかでありながら落ち着いた風合いが、日々のひとときを特別に演出します。</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/crafts3.jpg" alt="珠洲焼の器" onClick={() => openLightbox('/images/crafts3.jpg')} />
                        <div>
                            <h3>珠洲焼</h3>
                            <p>珠洲焼は、釉薬を使わずに焼き上げる独自の技法により、黒灰色の素朴で力強い質感が特徴です。鎌倉時代には一度廃れたものの、現代の作家により復興され、今では「使えるアート」として人気を博しています。</p>
                            <p>あけぼのの2階寝室では、実際に珠洲焼の小皿や酒器をご覧いただけます。その手触りや重量感をぜひご体感ください。</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/crafts4.jpg" alt="高澤ろうそくとお香" onClick={() => openLightbox('/images/crafts4.jpg')} />
                        <div>
                            <h3>高澤ろうそく</h3>
                            <p>能登七尾にて百年以上の歴史を持つ「高澤ろうそく」は、和ろうそくの柔らかく揺らぐ炎が特徴。一本一本手作業で作られるその姿には、能登の自然と職人の精神が宿っています。</p>
                            <p>現在は震災の影響を受け仮店舗で営業中ですが、あけぼのでは高澤ろうそくのお香を焚き、玄関やリビングでお客様を温かくお迎えしています。</p>
                        </div>
                    </div>
                </section>

                {/* Lightbox 拡大表示 */}
                {lightboxImage && (
                    <div className="lightbox" onClick={() => setLightboxImage(null)}>
                        {/* ▼▼▼ CORRECTED LIGHTBOX ▼▼▼ */}
                        <span className="lightbox-close">&times;</span>
                        <img src={lightboxImage} alt="拡大表示" className="lightbox-content" />
                    </div>
                )}
            </div>
        </> // ▲▲▲ Wrapped with Fragment <> ▲▲▲
    );
};

export default Craft;